import React from "react";
import { Row, Col, Typography, Form, Button, Space } from "antd";
import "./login.style.scss";
import { getEnvVars } from "../../Environment";
const { oAuthConfig } = getEnvVars();

const Login: React.FC = () => {
  const { Title } = Typography;

  const onFinish = (values: any) => {
    let redirect=oAuthConfig.recirect;
    let clientId=oAuthConfig.clientId;
    let respooseType=oAuthConfig.responseType;
    let scope=oAuthConfig.scope;
    window.location.href=`${getEnvVars().apiUrl}/connect/authorize?response_type=${respooseType}&client_id=${clientId}&redirect_uri=${redirect}&scope=${scope}&state=U3rgIEOOYhhAxMyAyMDIyIDE1OjM4OjA1IEdNVCsPMzMwIChJcmFuTFN0YW5kYXJTIFRggWUb`;
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="main-login">
      <Row justify="center" align="middle" style={{ height: "100vh" }}>
        <Col flex="380px">
          <div className="form-login p-3">
            <Space direction="vertical" style={{ alignItems: "center" }}>
              <Title level={2}>WMS Service</Title>
            </Space>
            <Form
              name="basic"
              wrapperCol={{ span: 24 }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
            >
              <Form.Item>
                <Button type="primary" htmlType="submit" className="w-100">
                  login
                </Button>
              </Form.Item>
            </Form>
            <Button type="dashed" htmlType="submit" className="w-100" onClick={()=>{window.location.href='http://api.aassttiinn.org/account/manage'}}>
                  Manage Account
             </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default Login;
